/**
 * 首页路由
 * 2017-12-6
 */
"use strict";
angular.module("homePageRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("index.homepage", {
        url: "/homepage",
        views: {
            "main@index": {
                templateUrl: "./main/homePage/homePage_tpl.html",
                controller: "homePageCtrl"
            }
        }
    });
}]);